import { Badge } from '@atoms/badges/Badge/Badge';

type AuthenticationStatusBadgeProps = {
  enabled: boolean;
};

export const AuthenticationStatusBadge = ({
  enabled
}: AuthenticationStatusBadgeProps) => (
  <Badge
    label={enabled ? 'Enabled' : 'Disabled'}
    className={enabled ? 'bg-status-completed' : 'bg-status-neutral'}
  />
);
